import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VisitsPerMemberWidget } from '../../models/loyalty-dashboard.model';

@Component({
  selector: 'app-visits-per-member-widget',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="stat-card">
      <span class="stat-card__label">Visits per member, monthly</span>
      <ng-container *ngIf="data as widget; else noData">
        <span class="stat-card__value">{{ widget.monthlyVisits | number : '1.0-1' }}</span>
        <span class="stat-card__detail">
          vs.
          <span class="stat-card__highlight">{{ widget.monthlyVisitsBeforeJoining | number : '1.0-1' }}</span>
          before they joined
        </span>
      </ng-container>
      <ng-template #noData>
        <p class="stat-card__empty">No data available.</p>
      </ng-template>
    </div>
  `,
  styleUrl: '../stat-card.scss',
})
export class VisitsPerMemberWidgetComponent {
  @Input() data: VisitsPerMemberWidget | null = null;
}
